var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4338CA",
  d: "M13.8 8.827v3.515a1 1 0 0 0 .553.894l2.085 1.043.19.08a1.632 1.632 0 0 0 2.16-1.333l.013-.208V7.181a1.635 1.635 0 0 0-2.363-1.46l-2.084 1.041a1 1 0 0 0-.553.895z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A5B4FC",
  d: "M11.201 6.667a.87.87 0 0 0-.867-.867H3.668a.87.87 0 0 0-.867.867v6.666a.87.87 0 0 0 .867.867h6.666a.87.87 0 0 0 .867-.867z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A5B4FC",
  d: "M11.201 6.667a.87.87 0 0 0-.867-.867H3.668a.87.87 0 0 0-.867.867v6.666a.87.87 0 0 0 .867.867h6.666a.87.87 0 0 0 .867-.867z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#A5B4FC",
  fillRule: "evenodd",
  d: "M12.8 8.827v4.506a2.466 2.466 0 0 1-2.466 2.467H3.668a2.467 2.467 0 0 1-2.467-2.467V6.667A2.467 2.467 0 0 1 3.668 4.2h6.666a2.467 2.467 0 0 1 2.467 2.467zm-1.853-2.773a.87.87 0 0 1 .254.613v6.666a.87.87 0 0 1-.867.867H3.668a.87.87 0 0 1-.867-.867V6.667a.87.87 0 0 1 .867-.867h6.666c.23 0 .45.091.613.254",
  clipRule: "evenodd"
})));
export default SvgVideo;